import {
  RetrieveFighterImage,
  RetrieveFighterImageFailure,
  RetrieveFighterImagePayload,
  RetrieveFighterImageSuccess,
  RetrieveFighterImageSuccessPayload,
  RETRIEVE_FIGHTER_IMAGE,
  RETRIEVE_FIGHTER_IMAGE_FAILURE,
  RETRIEVE_FIGHTER_IMAGE_SUCCESS,
} from './image.action.type';

export const retrieveFighterImage = (
  payload: RetrieveFighterImagePayload,
): RetrieveFighterImage => ({
  type: RETRIEVE_FIGHTER_IMAGE,
  payload,
});

export const retrieveFighterImageSuccess = (
  payload: RetrieveFighterImageSuccessPayload,
): RetrieveFighterImageSuccess => ({
  type: RETRIEVE_FIGHTER_IMAGE_SUCCESS,
  payload,
});

export const retrieveFighterImageFailure = (
  error: string,
): RetrieveFighterImageFailure => ({
  type: RETRIEVE_FIGHTER_IMAGE_FAILURE,
  payload: error,
});
